export default {
  ACTIVITY: 'Activitet',
  ACTIVITY_NAVIGATION_PREV: 'Forrige',
  ACTIVITY_NAVIGATION_NEXT: 'Neste',
  ACTIVITY_NAVIGATION_CONTINUE: 'Fortsette',
  ACTIVITY_NAVIGATION_FINISH: 'Ferdig',
}
